import { updateChangeStatus } from "./chat";
import { showToast } from "./utils";
import { useSelector, useDispatch } from "react-redux";
import {
  setMessage,
  removeScrollMessage,
} from "../../../store/operator/actions";
import { resetClientInfo } from "../../../store/clientInformation/actions";
import { useHistory } from "react-router-dom";

const useCloseConversation = () => {
  const { messageOperator } = useSelector((state) => state.Operator);
  const dispatch = useDispatch();
  const history = useHistory();

  return {
    handleClosedByClient: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e?.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        const { hasPosChat } = data;
        const status = hasPosChat ? "pos-chat" : "closed";

        updateChangeStatus(
          chatId,
          status,
          messageOperator,
          dispatch,
          setMessage
        );
        showToast(
          "info",
          `${t("Chat closed by client")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );

        dispatch(resetClientInfo(chatId));
        dispatch(removeScrollMessage(chatId));

        if (spyConversation)
          setTimeout(() => history.push("/manager-panel"), 3000);
      }
    },

    handleClosedByAgent: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e?.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        const { hasPosChat } = data;
        const status = hasPosChat ? "pos-chat" : "closed";

        updateChangeStatus(
          chatId,
          status,
          messageOperator,
          dispatch,
          setMessage
        );
        showToast(
          "info",
          `${t("Chat closed by agent")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );

        dispatch(resetClientInfo(chatId));
        dispatch(removeScrollMessage(chatId));

        if (spyConversation)
          setTimeout(() => history.push("/manager-panel"), 3000);
      }
    },

    handleClosedByManager: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e?.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        const { hasPosChat } = data;
        const status = hasPosChat ? "pos-chat" : "closed";

        updateChangeStatus(
          chatId,
          status,
          messageOperator,
          dispatch,
          setMessage
        );
        showToast(
          "info",
          `${t("Chat closed by manager")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );

        dispatch(resetClientInfo(chatId));
        dispatch(removeScrollMessage(chatId));

        if (spyConversation)
          setTimeout(() => history.push("/manager-panel"), 3000);
      }
    },

    handleClosedBySystem: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e?.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        const { hasPosChat } = data;
        const status = hasPosChat ? "pos-chat" : "closed";

        updateChangeStatus(
          chatId,
          status,
          messageOperator,
          dispatch,
          setMessage
        );
        showToast(
          "info",
          `${t("Chat closed by system")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );

        dispatch(resetClientInfo(chatId));
        dispatch(removeScrollMessage(chatId));

        if (spyConversation)
          setTimeout(() => history.push("/manager-panel"), 3000);
      }
    },
  };
};

export default useCloseConversation;
